module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/CW-6f137fecd8875f8f41e0b3518349ced9.png";